import { IAccordionItem } from 'ui/interface/contents/accordion/IAccordion';
import { extractSlateText } from '../slateEditor.utils';

export const getAccordionTitle = (accordion: IAccordionItem): string => extractSlateText(accordion.title);
export const getAccordionBody = (accordion: IAccordionItem): string => extractSlateText(accordion.body);
